import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#000000'
const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 24,
    fontStyle: 'bold',
  },
  description: {
    width: '50%',
    textAlign: 'left',
    borderRightColor: borderColor,
    borderLeftColor: borderColor,
    borderLeftWidth: 1,
    paddingLeft: 8,
    lineHeight: '1.4',
    fontSize: 14
  },
  topBorder: {
    borderBottomWidth: 1,
  },
  emptyField: {
    width: '50%',
    textAlign: 'left',
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingLeft: 8,
    lineHeight: '1.4',
    fontSize: 14
  }
});

const TableComponent = ({ componentData }) => {
  const rows = componentData.map(item =>
    <View>
      <View style={styles.topBorder} />
      <View style={styles.row} key={componentData._id}>
        <Text style={styles.description}>{item.label}:</Text>
        <Text style={styles.emptyField}> </Text>
      </View>
    </View>
  )
  return (
    <Fragment>
      {rows}
      <View style={{borderTopWidth: 1}} />
    </Fragment>)
}

export default TableComponent
